const rootDataSet = document.getElementById('root')?.dataset;

/**
 * Retrieves the build hash if the root element's dataset contains keys: "gameVersion", "coreVersion" and "buildNumber".
 *
 * @returns {string} The build hash consisting of game version, core version, and build number separated by hyphens. If any of these are undefined, returns null.
 */
const getBuildHash = (): string | null => {
  if (rootDataSet && rootDataSet.gameVersion && rootDataSet.coreVersion && rootDataSet.buildNumber) {
    return `${rootDataSet.gameVersion}-${rootDataSet.coreVersion}-${rootDataSet.buildNumber}`;
  }

  return null;
};

const buildHash = getBuildHash();

export const buildHashParam = buildHash ? { params: { buildHash } } : {}; // Avoids using build hash in Storybook
